class Member {
  constructor() {
    this.groups = [];
    this.members = Array.prototype.slice.call(document.querySelectorAll('.lc-member'));
    this.aboutClass = '.lc-member__about';
    this.educationClass = '.lc-member__education';
    this.careerClass = '.lc-member__career';
    this.externalClass = '.lc-member__external';

    this.memberOffsets = [0, 0, 0, 0];

    if (this.members && this.members.length !== 0) {
      this.buildGroups();
      this.calculateHeights();
    }

    window.addEventListener('resize', () => {
      this.resetHeights();
    });

  }

  buildGroups() {
    this.members.forEach(member => {
      const parent = member.closest('.wp-content__inner > *');

      const existingGroup = this.groups.find(group => group.parent === parent);
      if (existingGroup) {
        existingGroup.children.push(member);
      } else {
        this.groups.push({
          parent: parent,
          children: [member],
          heights: [0, 0, 0, 0]
        })
      }
    });
  }

  calculateHeights() {
    this.groups.forEach(group => {
      group.children.forEach(child => {
        let about = child.querySelector(this.aboutClass).clientHeight;
        let education = child.querySelector(this.educationClass).clientHeight;
        let career = child.querySelector(this.careerClass).clientHeight;
        let external = child.querySelector(this.externalClass).clientHeight;

        if (about > group.heights[0]) {
          group.heights[0] = about;
        }

        if (education > group.heights[1]) {
          group.heights[1] = education;
        }

        if (career > group.heights[2]) {
          group.heights[2] = career;
        }

        if (external > group.heights[3]) {
          group.heights[3] = external;
        }
      });
    });

    this.bindHeights();
  }

  bindHeights() {
    if (window.innerWidth >= 768) {
      this.groups.forEach(group => {
        group.children.forEach(child => {
          child.querySelector(this.aboutClass).style.height = group.heights[0] + "px";
          child.querySelector(this.educationClass).style.height = group.heights[1] + "px";
          child.querySelector(this.careerClass).style.height = group.heights[2] + "px";
          child.querySelector(this.externalClass).style.height = group.heights[3] + "px";
        });
      })
    };
  }

  resetHeights() {

    this.groups.forEach(group => {
      group.children.forEach(child => {
        child.querySelector(this.aboutClass).style.height = "auto";
        child.querySelector(this.educationClass).style.height = "auto";
        child.querySelector(this.careerClass).style.height = "auto";
        child.querySelector(this.externalClass).style.height = "auto";
      });

      group.heights = [0, 0, 0, 0]
    })

    this.calculateHeights();
  }
}

export default Member;

// default group
// {
//   parent: null,
//   children: [],
//   heights: []
// }
